import { TinyEmitter } from 'tiny-emitter';
export default class EventBus {
    static get instance() {
        const _window = window;
        if (!('VPEventBus' in _window) || !_window.VPEventBus) {
            _window.VPEventBus = new TinyEmitter();
            // Add aliases for Vue2 backwards compatibility
            _window.VPEventBus.$all = _window.VPEventBus.all;
            _window.VPEventBus.$emit = _window.VPEventBus.emit;
            _window.VPEventBus.$off = _window.VPEventBus.off;
            _window.VPEventBus.$on = _window.VPEventBus.on;
        }
        return _window.VPEventBus;
    }
}
//# sourceMappingURL=event-bus.js.map